import { useQuery } from '@tanstack/react-query';

import { api } from '../config/api';
import type {
  CarouselRunCardRow,
  CarouselRunPostRow,
  CarouselRunRow,
} from '../types/api';

export function useRuns(limit = 50) {
  return useQuery({
    queryKey: ['runs', limit],
    queryFn: () => api<CarouselRunRow[]>(`/carousel/runs?limit=${limit}`),
    staleTime: 30 * 1000,
  });
}

export function useRun(runId: string | null) {
  return useQuery({
    queryKey: ['run', runId],
    queryFn: () =>
      api<{
        run: CarouselRunRow;
        cards: CarouselRunCardRow[];
        posts: CarouselRunPostRow[];
      }>(`/carousel/runs/${String(runId)}`),
    enabled: Boolean(runId),
  });
}
